import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16ffedb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-v-bar" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "switch-bar"
}

import { ref, inject } from "vue";
import { Switch } from "vant";

export default /*#__PURE__*/_defineComponent({
  __name: 'Title',
  props: {
  text: {
    type: String,
  },
  open: {
    type: Boolean,
    default: false,
  },
},
  emits: ["change-switch"],
  setup(__props, { emit: emits }) {

const isMove = inject("isMove", false);


const checked = ref(false);

function changeSwitch(value: boolean) {
  emits("change-switch", value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h2", {
    class: _normalizeClass({ title: _unref(isMove), 'pc-title': !_unref(isMove) })
  }, [
    _hoisted_1,
    _createElementVNode("div", null, _toDisplayString(__props.text), 1),
    (__props.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Switch), {
            modelValue: checked.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
            "active-color": "#000",
            "inactive-color": "rgb(215, 216, 218)",
            class: "sw",
            onChange: changeSwitch
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.text), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})